<div
    class="tw-relative tw-max-w-full tw-h-[442px] tw-max-h-[442px] tw-overflow-hidden tw-bg-[url('assets/images/Jc3/mobile-banner.png')] tw-bg-cover tw-bg-center"
>
    <img
        *ngIf="mobileBanner"
        class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full"
        [src]="mobileBanner"
    />
</div>
